import { createSlice } from '@reduxjs/toolkit';
import { MediaQueries } from '~/constants/constVars';
import { MatchedMediaBreakPoints } from '~/Interfaces';

const matchedMediaInitialState: MatchedMediaBreakPoints = Object.freeze({
  mobile: false,
  smallScreen: false,
  mobileLandscape: false,
  smallScreenPortrait: false,
  mediumScreen: false,
  bigScreen: false,
  portrait: false,
  landscape: false,
  tablet: false,
  desktop: false,
});

const matchedMediaSlice = createSlice({
  name: 'matchedMedia',
  initialState: matchedMediaInitialState,
  reducers: {
    updateMatchedMedia: (state) => {
      Object.keys(MediaQueries).forEach((query) => {
        state[query as keyof MatchedMediaBreakPoints] = window.matchMedia(
          MediaQueries[query as keyof MatchedMediaBreakPoints]
        ).matches;
      });
    },
  },
});

export const { updateMatchedMedia } = matchedMediaSlice.actions;

export default matchedMediaSlice.reducer;
